import Vue from 'vue'
import Router from 'vue-router'
import index from '../views/index'
import home from '../views/home'

Vue.use(Router)

export default new Router({
  mode: 'hash', 
  routes: [
    {
      path: '/',
      name: 'home',
      component:home,
      redirect: '/index',
      children: [
        {
          path: '/index',
          name: 'index',
          component:index
        },
        {
          path: '/news',//新闻动态
          name: 'news',
          component: () => import('./../views/pages/news.vue')
        },
        {
          path: '/newsdetail',//文章详情
          name: 'newsdetail',
          component: () => import('./../views/pages/newsdetail.vue')
        },
        {
          path: '/videos',
          name: 'videos',
          component: () => import('./../views/pages/videos.vue')
        },
        {
          path: '/videodetail',//视频详情
          name: 'videodetail',
          component: () => import('./../views/pages/videodetail.vue')
        },
        {
          path: '/initiatives',
          name: 'initiatives',
          component: () => import('./../views/pages/initiatives.vue')
        },
        {
          path: '/initiativesdetail',//措施详情
          name: 'initiativesdetail',
          component: () => import('./../views/pages/initiativesdetail.vue')
        },

        {
          path: '/actionposter',
          name: 'actionposter',
          component: () => import('./../views/pages/actionposter.vue')
        },
        {
          path: '/actionposterdetail',//行动海报详情
          name: 'actionposterdetail',
          component: () => import('./../views/pages/actionposterdetail.vue')
        },

        //企业成就
        {
          path: '/enterprise',
          name: 'enterprise',
          component: () => import('./../views/pages/enterprise.vue')
        },
        {
          path: '/enterprisedetail',
          name: 'enterprisedetail',
          component: () => import('./../views/pages/enterprisedetail.vue')
        },
        {
          path: '/comingsoon',
          name: 'comingsoon',
          component: () => import('./../views/pages/comingsoon.vue')
        },
        {
          path: '/professionals',
          name: 'professionals',
          component: () => import('./../views/pages/professionals.vue')
        },
        {
          path: '/threetype',
          name: 'threetype',
          component: () => import('./../views/pages/threetype.vue')
        },
        {
          path: '/erjian',
          name: 'erjian',
          component: () => import('./../views/pages/erjian.vue')
        },
        {
          path: '/gongren',
          name: 'gongren',
          component: () => import('./../views/pages/gongren.vue')
        },
        {
          path: '/anquanyuan',
          name: 'anquanyuan',
          component: () => import('./../views/pages/anquanyuan.vue')
        },
        {
          path: '/help',
          name: 'help',
          component: () => import('./../views/pages/help.vue')
        },
        {
          path: '/answer',
          name: 'answer',
          component: () => import('./../views/pages/answer.vue')
        }
        
      ]
    },
    
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js